import React, { useState, useEffect } from 'react'
// import { Provider } from 'react-redux'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
// import store from './redux/store'
import Loading from './assets/img/Loading.json'
import Lottie from 'lottie-react'
import Dashboard from './components/Dashboard'
import Login from './components/Login'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
// import { AuthProvider } from './context/authContext';

function App() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchDashboardData = async () => {
      setTimeout(() => {
        setLoading(false)
      }, 2000)
    }
    fetchDashboardData()
  }, [])

  return (
    /*<Provider store={store}>*/ 
    <AuthProvider>
      <BrowserRouter>
        <div>
          <Routes>
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  {loading ? <Lottie animationData={Loading} /> : <Dashboard />}
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={<Login />}
            />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
    /*     </Provider>    */
  )
}

export default App
